<template>

  <v-card>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>
<!--        <span v-if="!!id">Изменить публикационную активность</span>-->
<!--        <span v-else> <div>Добавить публикационную активность </div></span>-->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-toolbar-items>
          <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout row wrap  align-center justify-center fill-height>
      <v-flex xs12   md10>
    <v-card-text>

      <v-card-text>
        <strong>
          <div>Сведения о публикационной активности кандидатов в члены диссертационного совета</div>
        </strong>
      </v-card-text>
      <v-card-text>
        <div>(заполняется за 5 лет, предшествующих году подачи ходатайства о создании диссертационного совета по каждому
          члену диссертационного совета; указываются
        </div>
        <div>только публикации и научные мероприятия, относящиеся к научной специальности, представляемой в
          диссертационном совете)
        </div>
      </v-card-text>


        <v-layout row wrap   align-center justify-center fill-height>
          <v-flex xs12 md7>
            <v-text-field
              v-model="value.fio"
              label="Фамилия имя отчество"
              :error="hasError('fio')"
              :error-messages="getError('fio')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md7>
            <v-text-field
              v-model="value.birth"
              label="Год рождения"
              type="date"
              :error="hasError('birth')"
              :error-messages="getError('birth')"
            ></v-text-field>
          </v-flex>
            <v-flex xs12 md7>
             <v-autocomplete
               v-model="value.citizenship"
               :items="selectors.countries"
               item-text="country"
              item-value="country"
              label="Гражданство"
              placeholder="Выберите..."
               :error="hasError('citizenship')"
               :error-messages="getError('citizenship')"
             > </v-autocomplete>
            </v-flex>
          <v-flex xs12 md7 >
            <v-autocomplete
              v-model="value.academic_degree"
              label="Ученая степень"
              :items="selectors.academic_degree"
              placeholder="Выберите..."
              :error="hasError('academic_degree')"
              :error-messages="getError('academic_degree')"
            > </v-autocomplete>
            <v-text-field
              v-model="value.status"
              label="Статус в совете"
              :error="hasError('status')"
              :error-messages="getError('status')"
            ></v-text-field>
            <v-text-field
              v-model="value.speciality"
              label="Шифр научной специальности (отрасль науки),представляемой в совете"
              :error="hasError('speciality')"
              :error-messages="getError('speciality')"
            ></v-text-field>
            <v-text-field
              v-model="value.researcherID"
              label="Researcher ID (Web of Science)"
              :error="hasError('researcherID')"
              :error-messages="getError('researcherID')"
            ></v-text-field>
            <v-text-field
              v-model="value.authorID"
              label="Author ID (Scopus)"
              :error="hasError('authorID')"
              :error-messages="getError('authorID')"
            ></v-text-field>
            <v-text-field
              v-model="value.SPIN"
              :error="hasError('SPIN')"
              :error-messages="getError('SPIN')"
              label="SPIN (РИНЦ)"
            ></v-text-field>
            <v-text-field
              v-model="value.count_international_publications"
              label="Количество публикаций в международных базах данных"
              :error="hasError('count_international_publications')"
              :error-messages="getError('count_international_publications')"
            ></v-text-field>
            <v-text-field
              v-model="value.count_reviewed_publications"
              :error="hasError('count_reviewed_publications')"
              :error-messages="getError('count_reviewed_publications')"
              label="Количество публикаций в журналах из Перечня рецензируемых научных изданий3 (без дублирования публикаций в изданиях, входящих в международные базы)"
            ></v-text-field>
            <v-text-field
              v-model="value.count_international_events"
              label="Количество международных научных мероприятий"
              :error="hasError('count_international_events')"
              :error-messages="getError('count_international_events')"
            ></v-text-field>
            <v-text-field
              :error="hasError('count_russian_events')"
              :error-messages="getError('count_russian_events')"
              v-model="value.count_russian_events"
              label="Количество всероссийских научных мероприятий"
            ></v-text-field>

    <input @change="setFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" name="image" ref="inputUploadFile"
           style="font-size: 1.2em; padding: 10px 0;"
           type="file"
           v-show="false"/>
    <v-layout class="pa-3 ma-3">

      <v-input
        :error="hasError('publications')"
        :error-messages="getError('publications')"
      >
        Прикрепленный файл списка публикаций в формате exel: <a v-if="value.publications !=='' && typeof value.publications !== 'object'"
                                                 :href="value.publications" target="_blank" rel="noopener noreferrer">Файл
        изменений</a>
        <div v-if="typeof value.publications === 'object' && value.publications !== null"> {{value.publications.name}}</div>

      </v-input>

      <v-btn @click="$refs.inputUploadFile.click() "
             color="primary"
             flat>
        <v-icon>folder_open</v-icon>
        Прикрепить
      </v-btn>
    </v-layout>


            <v-btn block @click="save" color="primary">Сохранить</v-btn>
          </v-flex>
    </v-layout>


    </v-card-text>

    </v-flex>
    </v-layout>




    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 sm11 md6 lg4>
    <v-card-text>
      <strong>Публикации в изданиях, входящих в перечень рецензируемых научных изданий</strong>
    </v-card-text>

    <v-card-text>
      <ul class="text-xs-left">
        <li> Авторы на языке оригинала по публикации (Фамилия И.О. - списком, разделитель - запятая)</li>
        <li> Название статьи на языке оригинала по публикации</li>
        <li> Наименование издания и выходные данные публикации (№ тома, № части тома, № журнала, страницы размещения
          статьи в журнале)
        </li>
        <li> Год выпуска журнала</li>
        <li> Импакт-фактор издания по РИНЦ (за 5 лет) (при наличии)</li>
        <li> DOI для электронных изданий (при наличии)</li>
      </ul>
    </v-card-text>
        </v-flex>
          <v-flex xs12 sm11 md6 lg4>
    <v-card-text>
      <strong>Публикации в изданиях, входящих в международные базы данных и системы цитирования</strong>
    </v-card-text>
    <v-card-text>
      <ul class="text-xs-left">
        <li> Авторы (фамилия и.о. - списком, разделитель - запятая) на языке оригинала по публикации (если он отличается
          от анг. яз.)
        </li>
        <li>Авторы (фамилия и.о. - списком, разделитель - запятая) на анг. яз. / транслитерация</li>
        <li> Название статьи на языке оригинала по публикации (если он отличается от анг. яз.)</li>
        <li> Название статьи на английском языке /транслитерация</li>
        <li> Наименование издания и выходные данные публикации (№ тома, № части тома, № журнала, страницы размещения
          статьи в журнале)
        </li>
        <li> Год выпуска журнала</li>
        <li> DOI для электронных изданий (при наличии)</li>
        <li> Публикация индексируется в международных базах данных и системах цитирования (указать каких, возможен
          множественный выбор вариантов): Web of Science
          , Scopus
          , Astrophysics
          , PubMed
          , Mathematics
          , Chemical Abstracts
          , Springer
          , GeoRef
          , MathSciNet
        </li>
      </ul>
    </v-card-text>
          </v-flex>
        <v-flex xs12 sm11 md6 lg4>
    <v-card-text>
      <strong>Научные мероприятия</strong>
    </v-card-text>
    <v-card-text>
      <ul class="text-xs-left">
        <li>Наименование научного мероприятия</li>
        <li>Дата проведения</li>
      </ul>
    </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
    <!--    <v-divider class="mt-5"></v-divider>-->

  </v-card>


</template>

<script>
    import country from "@/helper/country";
    import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
    import { makePostRequestFile} from "../../../helper";
    import urls from "../urls.js"
    export default {
        name: "Publications",
        mixins: [UserDataFormMixin],
        props: {
            petition: Number,
            selected: Object,
        },
        data() {
            return {
                URL_CREATE: '',
                URL_UPDATE: '',
                selectors: {
                    countries: [],
                    academic_degree: [
                        '-----',
                        'Кандидат наук',
                        "Доктор технических наук",
                        'Доктор химических наук',
                        "Доктор физико-математических наук",
                        "Доктор экономических наук",
                        "Доктор филосовских наук",
                        "Доктор психологических наук",
                        "Доктор исторических наук",
                        "Доктор юридических наук",
                        "Доктор геолого-минералогических наук",
                        "Доктор педагогических наук",
                        'Кандидат биологических наук',
                        'Кандидат филосовских наук',
                        'Кандидат экономических наук',
                        'Кандидат технических наук',
                        'Кандидат химических наук',
                        'Кандидат социологических наук',
                        'Кандидат физико-математических наук',
                        'Кандидат филологических наук',
                        'Кандидат психологических наук',
                        'Кандидат юридических наук',
                        'Кандидат педагогических наук',
                        'Кандидат исторических наук',
                    ],
                },

                value: {
                    fio:  '' ,
                    birth: '',
                    citizenship: '',
                    academic_degree: '',
                    status: '',
                    speciality: '',
                    researcherID: '',
                    authorID: '',
                    SPIN: '',
                    count_international_publications: '',
                    count_reviewed_publications: '',
                    count_international_events: '',
                    count_russian_events: '',
                    publications: null,
                },
                dialog: false,


            }
        },
        methods: {
            setFile(e) {
                const file = e.target.files[0];
                this.value.publications = file;
            },
            closeDialog() {
                this.$emit('ended', '')
            },
            initialize() {
                this.selectors.countries = country
                if(this.selected !== undefined){
                    let data = this.selected
                        for (var key in data) {
                            this.value[key] = data[key]
                        }
                }

            },
            save() {

                let url = urls.getUrl('admin|petition|petition|petition_create_permanent_council|candidate-list', 'create').replace('<petition>', this.petition)
                let method = 'POST'
                let data = Object.assign({},this.value)
                let ids = undefined
                if(this.selected!== undefined){
                   ids = this.selected.id
                }
                if (ids !== undefined) {
                    method = 'PATCH'
                    url = urls.getUrl('admin|petition|petition|petition_create_permanent_council|candidate-detail', 'partial_update').replace('<petition>', this.petition).replace('<id>', ids)
                    if (typeof (data.publications) === "string")
                        delete data.publications;
                }

                var formData = new FormData();

                for (var key in data) {
                    if(data[key] !== null)
                      formData.append(key, data[key])
                }

                let status = true;
                makePostRequestFile(url, formData, method)
                    .then(resp => {
                        if (!resp.ok) {
                            status = false;
                        }
                        return resp.json()
                    })
                    .then(json => {

                        if (status) {
                            this.$emit('ended', '');
                        } else {
                            this.receiveErrors(json);
                        }
                    })
            }

        },

        created() {
            this.initialize()
        },
    }

</script>

<style scoped>

</style>
